var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config
    ? _c(
        "div",
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.disabled,
              },
              model: {
                value: _vm.config.kngEnabled,
                callback: function ($$v) {
                  _vm.$set(_vm.config, "kngEnabled", $$v)
                },
                expression: "config.kngEnabled",
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_kng_upload_lbl_switch_faces" /** 开启人脸识别 */)
                ) + "\n  "
              ),
            ]
          ),
          _vm.config.kngEnabled
            ? _c(
                "yxt-form",
                {
                  ref: "form",
                  staticClass: "ml24",
                  attrs: {
                    model: _vm.config,
                    rules: _vm.rules,
                    "label-width": "auto",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pc_kng_relatedSetting_lbl_face_rule" /** 使用规则 */
                        ),
                        prop: "studyBeforeRecognition",
                      },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: {
                            disabled: _vm.disabled,
                            "true-label": 1,
                            "false-label": 0,
                          },
                          model: {
                            value: _vm.config.studyBeforeRecognition,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.config,
                                "studyBeforeRecognition",
                                $$v
                              )
                            },
                            expression: "config.studyBeforeRecognition",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_lbl_learning_before_face" /** 学习前进行人脸识别 */
                              )
                            ) + "\n      "
                          ),
                        ]
                      ),
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: {
                            disabled: _vm.disabled,
                            "true-label": 1,
                            "false-label": 0,
                          },
                          model: {
                            value: _vm.config.studyMiddleRecognition,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.config,
                                "studyMiddleRecognition",
                                $$v
                              )
                            },
                            expression: "config.studyMiddleRecognition",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_lbl_learning_in_face" /** 学习中进行人脸识别（需开启防挂机设置，学员触发防挂机时，需要进行人脸识别） */
                              )
                            ) + "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pc_kng_relatedSetting_lbl_face_type" /** 识别类型 */
                        ),
                        required: "",
                      },
                    },
                    [
                      _c(
                        "yxt-radio-group",
                        {
                          attrs: { direction: "row", disabled: _vm.disabled },
                          model: {
                            value: _vm.config.recognitionType,
                            callback: function ($$v) {
                              _vm.$set(_vm.config, "recognitionType", $$v)
                            },
                            expression: "config.recognitionType",
                          },
                        },
                        [
                          _c("yxt-radio", { attrs: { label: 0 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_lbl_base_img_face_self" /** 基于图片识别是否是本人 */
                                )
                              )
                            ),
                          ]),
                          _c("yxt-radio", { attrs: { label: 1 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_lbl_base_img_face_self_living" /** 基于图片+活体，识别是否是本人（拦截通过照片作假的场景）*/
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_kng_only_app" /** 仅App观看 */),
                      },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.config.appPlay,
                            callback: function ($$v) {
                              _vm.$set(_vm.config, "appPlay", $$v)
                            },
                            expression: "config.appPlay",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_lbl_only_app_play" /** 开启人脸识别的课程/课件，仅支持在App端观看 */
                              )
                            ) + "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }